import _ from "lodash";

import { getTranslation } from "helpers/common";
import { getDocument } from "../screens/app/actions";
import { localRequest } from "../apiUtils";
import Swal from "./swal";

export const downloadDocument = (data, onDownload = _.noop) => {
  if (data.DocumentId) {
    const documentName = !!data.Number
      ? data.Number
      : !!data.DeliveryId
      ? data.DeliveryId
      : data.DocumentId;
    getDocument(`/Documents(${data.DocumentId})/Document`)
      .then((file) => {
        onDownload();
        downloadFile(file, `${documentName}.pdf`);
      })
      .catch((err) => console.error(err.response));
  } else {
    Swal.alert("Info", getTranslation("NO_DOCUMENT"));
  }
};

export const downloadArealDocument = (data, onDownload = _.noop) => {
  if (data.Document && data.Document.Id) {
    const documentName = `${data.AreaStatement.HarvestYear}_${data.LicenceContractLine.LicenceContract.Cultivar}`;
    getDocument(`/Documents(${data.Document.Id})/Document`)
      .then((file) => {
        onDownload();
        downloadFile(file, `${documentName}.pdf`);
      })
      .catch((err) => console.error(err.response));
  } else {
    Swal.alert("Info", getTranslation("NO_DOCUMENT"));
  }
};

export const downloadDocuments = async (ids, name = "RESULT") => {
  if (ids.length >= 1) {
    await localRequest
      .get("pdf", { params: { ids }, responseType: "blob" })
      .then(({ data }) => {
        downloadFile(data, `${getTranslation(name)}.pdf`);
      })
      .catch((err) => console.error(err.response));
  } else {
    Swal.alert("Info", getTranslation("NO_AVAILABLE"));
  }
};

export const downloadFile = (file, name) => {
  if (file && file.size > 0) {
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file, name);
    } else {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(file);
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } else {
    Swal.alert("Info", getTranslation("NO_FILE"));
  }
};

export const downloadDeliveryNote = (file, fileName) => {
  if (window.navigator.msSaveOrOpenBlob) {
    // convert base64 to blob
    const byteString = atob(file.split(",")[1]);
    const mimeString = file.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const link = document.createElement("a");
    link.href = file;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
